import React from 'react';
import { ExclamationCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import './modalAlert.css';

export type ModalAlertType = 'success' | 'error' | 'warning' | 'info';

export interface ModalAlertProps {
  type: ModalAlertType;
  title: string;
  description?: string;
  visible: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  showCancelButton?: boolean;
}

const getIcon = (type: ModalAlertType) => {
  switch (type) {
    case 'success':
      return <CheckCircleOutlined className="modal-alert__icon modal-alert__icon--success" />;
    case 'error':
      return <CloseCircleOutlined className="modal-alert__icon modal-alert__icon--error" />;
    case 'warning':
      return <ExclamationCircleOutlined className="modal-alert__icon modal-alert__icon--warning" />;
    case 'info':
      return <InfoCircleOutlined className="modal-alert__icon modal-alert__icon--info" />;
    default:
      return null;
  }
};

export const ModalAlert: React.FC<ModalAlertProps> = ({
  type,
  title,
  description,
  visible,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  showCancelButton = false,
}) => {
  if (!visible) return null;

  return (
    <div className="modal-alert__overlay">
      <div className={`modal-alert modal-alert--${type}`}>
        <div className="modal-alert__icon-container">
          {getIcon(type)}
        </div>

        <h2 className="modal-alert__title">{title}</h2>

        {description && (
          <p className="modal-alert__description">{description}</p>
        )}

        <div className="modal-alert__footer">
          {showCancelButton && (
            <button
              className="modal-alert__button modal-alert__button--secondary"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            className={`modal-alert__button modal-alert__button--primary modal-alert__button--${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
